import { render, staticRenderFns } from "./Fold.vue?vue&type=template&id=565e4b68&scoped=true&lang=pug&"
import script from "./Fold.vue?vue&type=script&lang=js&"
export * from "./Fold.vue?vue&type=script&lang=js&"
import style0 from "./Fold.vue?vue&type=style&index=0&id=565e4b68&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "565e4b68",
  null
  
)

export default component.exports